import { Box, Grid, styled } from '@mui/material';

export const SideBarGrid = styled(Grid)(({ theme }) => ({
    height: '100%',
    padding: '16px 12px 0',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    gridTemplateRows: '1fr auto',
    minWidth: '248px',
    background: theme.palette.background.paper,
    [theme.breakpoints.down('lg')]: {
        minWidth: '230px',
    },
    '&::-webkit-scrollbar': {
        height: '0',
        width: '0',
    },
}));

export const SideBarContainer = styled(Box, {
    shouldForwardProp: prop => prop !== 'collapsed',
})<{ collapsed: boolean }>(({ theme, collapsed }) => [
    {
        border: 'none',
        background: 'transparent',
        zIndex: 1001,
        top: '0',
        position: 'sticky',
        height: '100vh',
        display: 'flex',
        flex: 'none',
        overflow: 'hidden',
    },
    collapsed && {
        width: '64px',
        [theme.breakpoints.down('lg')]: {
            width: '60px',
        },
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    !collapsed && {
        width: '248px',
        [theme.breakpoints.down('lg')]: {
            width: '230px',
        },
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
]);
